import { useLocalStorage } from '@vueuse/core'

type UseAlvaCookie = {
  isAccepted: ComputedRef<boolean>
  accept: () => void
  decline: () => void
  pauseHello: () => void
  shouldShowHello: ComputedRef<boolean>
}

export function useAlvaCookie(): UseAlvaCookie {
  const consentState = useLocalStorage<'1' | undefined>(
    'bs_alva_consent',
    () => undefined,
  )

  const isAccepted = computed(() => {
    return consentState.value === '1'
  })

  function accept() {
    consentState.value = '1'
  }

  function decline() {
    consentState.value = undefined
  }

  function pauseHello() {
    const helloShownState = useCookie('bs_alva_hello', {
      maxAge: 60 * 60 * 24,
      path: '/',
      secure: true,
    })
    helloShownState.value = 'pause'
  }

  const shouldShowHello = computed(() => {
    const helloShownState = useCookie('bs_alva_hello')

    return helloShownState.value !== 'pause' && !isAccepted.value
  })

  return {
    isAccepted,
    accept,
    decline,
    pauseHello,
    shouldShowHello,
  }
}
